var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2982_165149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8 10.7083C18.8 10.0583 18.7417 9.43325 18.6333 8.83325H10V12.3791H14.9333C14.7208 13.5249 14.075 14.4958 13.1042 15.1458V17.4458H16.0667C17.8 15.8499 18.8 13.4999 18.8 10.7083Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 19.6667C12.4753 19.6667 14.5503 18.8459 16.0669 17.4459L13.1044 15.1459C12.2836 15.6959 11.2336 16.0209 10.0003 16.0209C7.61276 16.0209 5.59193 14.4084 4.87109 12.2417H1.80859V14.6167C3.31693 17.6125 6.41693 19.6667 10.0003 19.6667Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.87051 12.2416C4.68717 11.6916 4.58301 11.1041 4.58301 10.5C4.58301 9.8958 4.68717 9.3083 4.87051 8.7583V6.3833H1.80801C1.18717 7.6208 0.833008 9.0208 0.833008 10.5C0.833008 11.9791 1.18717 13.3791 1.80801 14.6166L4.87051 12.2416Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 4.97909C11.3461 4.97909 12.5544 5.44159 13.5044 6.34992L16.1336 3.72075C14.5461 2.24159 12.4711 1.33325 10.0003 1.33325C6.41693 1.33325 3.31693 3.38742 1.80859 6.38325L4.87109 8.75825C5.59193 6.59159 7.61276 4.97909 10.0003 4.97909Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2982_165149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.80f8595cc348bd3467092d0d6c85b6c1.svg";
export { ForwardRef as ReactComponent };